// C4: acceso al Activity Center (asistente IA + actividad) sin botón flotante
// para usuarios logueados — los puntos de entrada fijos (sidebar del dashboard,
// barras superiores) disparan este evento y el ChatWidget global abre el panel.
export const OPEN_ACTIVITY_CENTER_EVENT = "aos:open-activity-center";

export const openActivityCenter = () =>
  window.dispatchEvent(new CustomEvent(OPEN_ACTIVITY_CENTER_EVENT));
